import { startAnalytics, toAnalyticsId, trackEvent } from './amplitude'

/** `feature` of the page view, by the page indicator `template-parts/analytics/main-scripts.php` renders. */
const pageFeatures: Record<string, string> = {
  isViewHome: 'home',
  isViewGuide: 'guide',
  isViewWorksheets: 'archive',
  isViewBlog: 'blog',
  isViewCategory: 'category',
  isViewPageSeo: 'article',
  isViewLand: 'landing',
  isViewTemplate: 'page'
}

const getInputValue = (selector: string): string =>
  document.querySelector<HTMLInputElement>(selector)?.value || ''

const trackPageView = (): void => {
  const inputPageIndicator = document.querySelector<HTMLInputElement>('#page-indicator')
  if (!inputPageIndicator) return

  const feature = pageFeatures[inputPageIndicator.value] || 'page'
  const name = toAnalyticsId(window.location.pathname) || 'home'
  const postTitle = getInputValue('#post-title')

  if (feature === 'article') {
    trackEvent('Page_view', { feature, name, text: postTitle, item_type: getInputValue('#category-title') })
  } else if (feature === 'landing') {
    trackEvent('Page_view', { feature, name, text: postTitle })
  } else {
    trackEvent('Page_view', { feature, name })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  void startAnalytics()
  trackPageView()
})
